import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Log } from 'src/app/models/services/logs/add-log.model';
import { DateOnlyResponse } from 'src/app/models/services/date-only-response.model';
import { LogResponse } from 'src/app/models/services/logs/log-service-response.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class LogService {
  constructor(private http: HttpClient) {}

  addLog(sendlog: Log): Observable<DateOnlyResponse> {
    return this.http.post<DateOnlyResponse>(
      environment.apiUrl + '/logs',
      sendlog,
      httpOptions
    );
  }

  getLogs(
    page: number,
    pageSize: number,
    startDate: Date | null,
    endDate: Date | null,
    severity = '',
    userOid = '',
    onBehalfOfUserOid = '',
    method = '',
    groupeEtablissement = '',
    roles = ''
  ): Observable<LogResponse> {
    let params = new HttpParams().appendAll({
      page: page,
      pageSize: pageSize,
    });

    if (severity) params = params.append('severity', severity);
    if (userOid) params = params.append('userOid', userOid);
    if (onBehalfOfUserOid)
      params = params.append('onBehalfOfUserOid', onBehalfOfUserOid);
    if (method) params = params.append('method', method);
    if (startDate) params = params.append('startDate', startDate.toISOString());
    if (endDate) params = params.append('endDate', endDate.toISOString());
    if (roles) params = params.append('roles', roles);
    if (groupeEtablissement)
      params = params.append('groupeEtablissement', groupeEtablissement);

    return this.http.get<LogResponse>(`${environment.apiUrl}/logs`, {
      params: params,
      headers: httpOptions.headers,
    });
  }

  getDistinctGE(): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.apiUrl}/logs/distinct-groupe-etablissement`
    );
  }

  getDistinctRoles(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/logs/distinct-roles`);
  }
}
